import { render, staticRenderFns } from "./centurion-membership.vue?vue&type=template&id=5241a11a&scoped=true&"
import script from "./centurion-membership.vue?vue&type=script&lang=js&"
export * from "./centurion-membership.vue?vue&type=script&lang=js&"
import style0 from "./centurion-membership.vue?vue&type=style&index=0&id=5241a11a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5241a11a",
  null
  
)

export default component.exports